import React from "react";

import { T } from "../../components";
import * as s from "./footer.module.css";
import Heart from "./heart.inline.svg";

export const Footer = () => {
	return (
		<div>
			<div className={s.content}>
				© 2023&nbsp;
			</div>
		</div>
	);
};
